module.exports = __webpack_public_path__ + "img/Tasty-Drops.3f8232ad.png";